import crud from './_crud'
import { callApi } from 'utils/api'
const actions = crud(
	'incident_category',
	'la categoría de incidencia',
	'las subcategorias de incidencias'
)

export default actions